import { render, staticRenderFns } from "./ReportOtherCompoment.vue?vue&type=template&id=f8249492&scoped=true"
import script from "./ReportOtherCompoment.vue?vue&type=script&lang=js"
export * from "./ReportOtherCompoment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8249492",
  null
  
)

export default component.exports